import React from 'react';
import type { FC } from 'react';
import { Spinner, useAsync } from '@wix/cli-ui-kit';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { wixCliLoginStart, wixCliLoginEnd } from '@wix/bi-logger-wix-cli/v2';
import { match } from 'variant';
import { apiKeyAuthStrategy } from '../auth-strategies/index.js';
import type { AuthStrategyState } from '../auth-strategies/index.js';

interface Props {
  token: string;
  onLogin: (data: AuthStrategyState) => void;
  onError: (error: unknown) => void;
}

export const ApiKeyLogin: FC<Props> = ({ token, onLogin, onError }) => {
  const biLogger = useBiLogger();

  const { status } = useAsync(
    async () => {
      void biLogger.report(wixCliLoginStart({}));

      return apiKeyAuthStrategy.login({ token });
    },
    [],
    {
      onSuccess: (authData) => {
        void biLogger.report(
          wixCliLoginEnd({
            isSuccess: true,
          })
        );
        onLogin(authData);
      },
      onError: (error) => {
        void biLogger.report(
          wixCliLoginEnd({
            isSuccess: false,
            ...(error instanceof Error
              ? {
                  errorType: error.name,
                }
              : {
                  errorType: 'unknown',
                  errorMessage: JSON.stringify(error),
                }),
          })
        );

        onError(error);
      },
    }
  );

  return match(status, {
    Error: () => null,
    Loading: () => <Spinner />,
    Success: () => null,
  });
};
